import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'edit-btn',
	template: require('./edit-btn.html'),
	styles: [require('./edit-btn.scss')]
})
export class EditBtnComponent implements OnInit {
	@Input() text: string;
	@Input() isEmpty: boolean;
	@Input() isLink: boolean;
	@Input() linkHref: string;
	@Input() isDisabled: boolean;
	@Input() addClass: string;
	btnText: string;

	constructor() {}

	ngOnInit() {
		this.btnText = this.text || 'Edit';
		if (this.isEmpty) {
			this.btnText = '';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/buttons/edit-btn/edit-btn.ts